import React from 'react';

const ImageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M20.75 4.25H4.25C3.85218 4.25 3.47064 4.40804 3.18934 4.68934C2.90804 4.97064 2.75 5.35218 2.75 5.75V19.25C2.75 19.6478 2.90804 20.0294 3.18934 20.3107C3.47064 20.592 3.85218 20.75 4.25 20.75H20.75C21.1478 20.75 21.5294 20.592 21.8107 20.3107C22.092 20.0294 22.25 19.6478 22.25 19.25V5.75C22.25 5.35218 22.092 4.97064 21.8107 4.68934C21.5294 4.40804 21.1478 4.25 20.75 4.25ZM20.75 5.75V15.3828L18.3059 12.9397C18.1666 12.8004 18.0013 12.6898 17.8193 12.6144C17.6372 12.539 17.4422 12.5002 17.2452 12.5002C17.0481 12.5002 16.8531 12.539 16.6711 12.6144C16.489 12.6898 16.3237 12.8004 16.1844 12.9397L14.3094 14.8147L10.1844 10.6897C9.9031 10.4086 9.52172 10.2507 9.12406 10.2507C8.72641 10.2507 8.34503 10.4086 8.06375 10.6897L4.25 14.5034V5.75H20.75ZM4.25 16.625L9.125 11.75L16.625 19.25H4.25V16.625ZM20.75 19.25H18.7466L15.3716 15.875L17.2466 14L20.75 17.5044V19.25ZM14 9.875C14 9.6525 14.066 9.43499 14.1896 9.24998C14.3132 9.06498 14.4889 8.92078 14.6945 8.83564C14.9 8.75049 15.1262 8.72821 15.3445 8.77162C15.5627 8.81502 15.7632 8.92217 15.9205 9.0795C16.0778 9.23684 16.185 9.43729 16.2284 9.65552C16.2718 9.87375 16.2495 10.1 16.1644 10.3055C16.0792 10.5111 15.935 10.6868 15.75 10.8104C15.565 10.934 15.3475 11 15.125 11C14.8266 11 14.5405 10.8815 14.3295 10.6705C14.1185 10.4595 14 10.1734 14 9.875Z"
        fill="#111927"
      />
    </svg>
  );
};

export default ImageIcon;
